import React, { useState } from 'react'
import injectSheet from 'react-jss'
import styles from './media.styles'
import classNames from 'classnames'

const Media = ({ classes, media, description }) => {
  const [loading, setLoading] = useState(true)
  return (
    <div className={classes.container}>
      {description && <p className={classes.desc}>{description}</p>}
      {media && (
        <img
          src={media.image_url}
          className={classNames(classes.image, {
            [classes.hidden]: loading
          })}
          onLoad={() => setLoading(false)}
          alt="Piece of writing"
        />
      )}
    </div>
  )
}

export default injectSheet(styles)(Media)
